import {Box, LoadingOverlay, ScrollArea, Tabs} from "@mantine/core";
import {Header} from "./Header";
import {useParams} from "react-router";
import {TProtocolDefinitionId} from "../../../types/protocolDefinitions";
import classes from "./PDefDashboard.module.css"
import commonClasses from "../../../../common/common.module.css"
import cx from "clsx";
import React, {useEffect, useState} from "react";
import {useDashboardStore} from "../store";
import {useNeurotuneStore} from "../../../../common/store/neurotune";
import {SubjectSessionsPanel} from "./SubjectSessionsPanel";
import {TimelinePanel} from "./TimelinePanel";
import dayjs from "dayjs";
import {StatCards, StatCardsProps} from "../StatCards";

export interface PDefDashboardProps {
}

export const PDefDashboard: React.FC<PDefDashboardProps> = ({}: PDefDashboardProps) => {
    const reset = useDashboardStore((state) => state.reset)
    const activeCompany = useNeurotuneStore((state) => state.activeCompany)
    const pdefId = useParams().pdef_id as TProtocolDefinitionId
    const protocolDefStats = useDashboardStore((state) => state.protocolDefStats)
    const protocolStats = useDashboardStore((state) => state.protocolStats)
    const loadProtocolDefStats = useDashboardStore((state) => state.loadProtocolDefStats)
    const loadProtocolStats = useDashboardStore((state) => state.loadProtocolStats)
    const pdefStats = protocolDefStats?.find((ps) => ps.pdefId === pdefId)
    const [scrolled, setScrolled] = useState(false);



    useEffect(() => {
        // always reset when pdefId changes to ensure fresh data
        reset()
        // this should be optimized later to only load the specific pdef stats we need
        loadProtocolDefStats(activeCompany.id)
        loadProtocolStats(activeCompany.id, pdefId)
    }, [pdefId])

    if (!pdefStats)
        return <LoadingOverlay visible={true} zIndex={1000}/>

    const cardStats: StatCardsProps = {
        stimStepCount: pdefStats.stimCount,
        totalStimTime: dayjs.duration({seconds: pdefStats.totalStimSeconds}),
        megScanCount: pdefStats.megScanCount,
        totalMegScanDuration: dayjs.duration({seconds: pdefStats.totalMEGSeconds}),
        eegScanCount: pdefStats.eegScanCount,
        totalEegScanDuration: dayjs.duration({seconds: pdefStats.totalEEGSeconds}),
        sessionCount: pdefStats.sessionCount,
        completedCount: pdefStats.completedCount,
    }

    return (
        <Box className={cx(classes.root)}>
            <ScrollArea className={cx(classes.scrollarea)}
                        onScrollPositionChange={({y}) => setScrolled(y !== 0)}
            >
                <Box className={cx(classes.content)}>
                    <Header title={pdefStats.name} subjectCount={pdefStats.numUniqueSubjects}
                            lastSessionStart={pdefStats.lastSessionStart}/>
                    <Box style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap"
                    }}>
                        <StatCards {...cardStats}/>
                    </Box>
                    <Tabs defaultValue={"timeline"}
                          variant={"pills"}
                          className={cx(classes.tabs, commonClasses.sbRadius)}>
                        <Tabs.List className={cx(commonClasses.tgbBorder)}>
                            <Tabs.Tab m="0" value={"timeline"}>
                                Timeline
                            </Tabs.Tab>
                            <Tabs.Tab m="0" value={"subjects"}>
                                Subjects
                            </Tabs.Tab>
                            <Tabs.Tab m="0" value={"analytics"}>
                                Analytics
                            </Tabs.Tab>
                        </Tabs.List>
                        <Tabs.Panel value={"timeline"}>
                            <TimelinePanel pStats={protocolStats}/>
                        </Tabs.Panel>
                        <Tabs.Panel value={"subjects"}>
                            <SubjectSessionsPanel pStats={protocolStats}/>
                        </Tabs.Panel>
                        <Tabs.Panel value={"analytics"}>
                            Analytics
                        </Tabs.Panel>
                    </Tabs>
                </Box>
            </ScrollArea>
        </Box>
    )
}